<template>

    <div class="brandBtn text-center pointer prelative" :class="{stretch: stretch, negative: negative}">
        <!--            <h4>{{content}}</h4>-->
        <div class="d-flex justify-center">
            <div class="tt titleFont oneLiner">{{content}}</div>
            <!--                <v-spacer class="hidden-sm-and-down"></v-spacer>-->
            <div class="text-right align-self-center" style="position: absolute; right: 0.5em;">
                <v-icon class="myAccent">mdi-chevron-right</v-icon>
            </div>
        </div>
        <!--       <div v-html="content"></div>-->
    </div>

    <!--        <div class="box hidden-sm-and-down pointer">-->
    <!--            &lt;!&ndash;        <div class="img"></div>&ndash;&gt;-->
    <!--            <div class="bottom d-flex">-->
    <!--                <h3 class="flex-grow-1 text-truncate">{{content}}</h3>-->
    <!--                <div class="text-right align-self-center">-->
    <!--                    <v-icon class="myAccent">mdi-chevron-right</v-icon>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

</template>

<script>
    export default {
        name: "BrandButton",
        props: {
            content: {
                type: String,
            },
            stretch: {
                type: Boolean,
                default: true
            },
            negative: {
                type: Boolean,
                default: false
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../styles/base';

    .brandBtn {
        //https://www.w3schools.com/cssref/playit.asp?filename=playcss_border-style&preval=groove
        //border: 1px solid  $accent;
        color: white;
        /*h4{*/
        /*    color: black;*/
        /*}*/
        border-radius: $box-border-radius; //30px
        /*border-style: dotted solid;*/
        padding: 8px 2vw;

        overflow: hidden;

        /*<!--border: 2px solid $accent;-->*/
        background-color: $color-primary;
        //background: linear-gradient(45deg, #666 10%, black);
        /*background-color: rgba(black, 0.3);*/
        /*backdrop-filter: blur(7px);*/

        display: inline-block;

        .tt {
            /*font-weight: 700;*/
            font-size: 1.2em;
        }

        &.stretch {
            display: block;
            width: 100%;
        }

        &.negative {
            /*    //background-color: $accent;*/
            /*    //color: black;*/
            /*    backdrop-filter: initial;*/
            /*border-radius: 0;*/
            /*    padding: 12px 2vw;*/
            /*    !*border: none;*!*/
        }
    }


    /*Tablet style*/
    /*<!--.box {-->*/
    /*<!--    margin: 9px 0;-->*/
    /*<!--    text-transform: uppercase;-->*/
    /*<!--    !*margin: 8px 0;*!-->*/
    /*<!--    !*height: 220px;*!-->*/
    /*<!--    overflow: hidden;-->*/
    /*<!--    !*position: relative;*!-->*/

    /*<!--    //background-color: transparent;-->*/
    /*<!--    border: 2px solid $accent;-->*/
    /*<!--    background-color: $color-primary;-->*/
    /*<!--    color: $accent;-->*/
    /*<!--    transition: all 0.4s ease;-->*/

    /*<!--    //@include material-shadow(1);-->*/

    /*<!--    &:hover {-->*/
    /*<!--        !*background-color: #bbb;*!-->*/
    /*<!--        background-color: $color-hover;-->*/

    /*<!--        .img {-->*/
    /*<!--            filter: brightness(115%);-->*/
    /*<!--        }-->*/
    /*<!--    }-->*/

    /*<!--    !*.img {*!-->*/
    /*<!--    !*    transition: all 0.4s ease;*!-->*/
    /*<!--    !*    height: 190px;*!-->*/
    /*<!--    !*    background-position: center center;*!-->*/
    /*<!--    !*    !*background-position: 0 50%; //focused corner is bottom center*!*!-->*/
    /*<!--    !*    background-repeat: no-repeat;*!-->*/
    /*<!--    !*    background-size: cover;*!-->*/
    /*<!--    !*    !*background-image: url('../assets/bg2.jpg');*!*!-->*/
    /*<!--    !*}*!-->*/
    /*<!--}-->*/
    /*<!--.bottom {-->*/
    /*<!--    padding: 10px 12px 10px 25px;-->*/
    /*<!--}-->*/
    /*xxxx*/

</style>